import { Box, Typography } from '@mui/material';
import { useTranslation } from 'next-i18next';

import { Layout_experimental as NextZoneLayout, LayoutNoFooter } from '@larvitu/shared/next/layout';
import { Link } from '@larvitu/shared/next/mui';

import { Footer, Header } from '.';

import type { FooterProps } from './Footer';
import type { FC, ReactElement } from 'react';

export interface LayoutProps {
  children: ReactElement;
}

export const LayoutFooter: FC<
  Omit<FooterProps, 'siteBrand' | 'googleMapHref'> & {
    siteBrand?: FooterProps['siteBrand'];
    googleMapHref?: FooterProps['googleMapHref'];
  }
> = ({ siteBrand, other, ...props }) => {
  const { t } = useTranslation( 'contact' );

  return (
    <Footer
      other={other}
      siteBrand={siteBrand ?? (
        <Link href="/" display="block" noLinkStyle>
          <Box display="flex">
            <Box display="flex" justifyContent="center">
              <Typography
                lineHeight="unset"
                component="p"
                variant="h5"
                sx={{
                  color: 'text.primary',
                }}
              >
                {process.env.NEXT_PUBLIC_PAGE_TITLE}
              </Typography>
            </Box>
          </Box>
        </Link>
      )}
      email={process.env.NEXT_PUBLIC_NODEMAILER_RECEIVERS}
      address="Lietzenburger Str. 54, 10719 Berlin"
      phone="+49 30 8818598"
      googleMapHref="https://goo.gl/maps/T7fakgvoXbu83wZW9"
      openingHours={
        t( 'opening-hours', {
          ns: 'contact',
          returnObjects: true,
          defaultValue: [],
        } ) /* [{day: "Mo, Di, Do", time: "08:00 - 11:30 Uhr,<br>14:00 - 17:00 Uhr"},{day: "Mi, Fr", time: "08:00 - 11:30 Uhr"}] */
      }
      {...props}
    />
  );
};

// ---------------------------------------------------------------------------------------------------------------------

export const Layout: FC<LayoutProps> = ({ children }) => (
  <NextZoneLayout
    header={<Header />}
    footer={<LayoutFooter />}
  >
    {children}
  </NextZoneLayout>
);
